import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router";
import routes from "../Routing/routes";
import AuthorizedRoute from "../Routing/AuthorizedRoute";
import PublicRoute from "../Routing/PublicRoute";
import useTokenChangeHandler from "../../common/eventHandlers/useTokenChangeHandler";
import useLogoutRequestHandler from "../../common/eventHandlers/useLogoutRequestHandler";
import AppContext from "./AppContext";
import GlobalStyle from "../shared/styles/globalStyle";
import Loader from "../shared/components/Loader/Loader";
import ToastContainer from "../shared/components/Toast/ToastContainer";

const routeComponents = routes.map((routeConfig, index) => {
  const Component = lazy(routeConfig.loader);
  const RouteGuard =
    routeConfig.type === "authed" ? AuthorizedRoute : PublicRoute;

  return (
    <Route
      key={index}
      path={routeConfig.path}
      element={
        <RouteGuard>
          <Component />
        </RouteGuard>
      }
    />
  );
});

const App = () => {
  const [token] = useTokenChangeHandler();
  useLogoutRequestHandler();

  const context = {
    userToken: token,
  };

  return (
    <AppContext.Provider value={context}>
      <ToastContainer />
      <GlobalStyle />
      <Suspense fallback={<Loader />}>
        <Routes>
          {routeComponents}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </AppContext.Provider>
  );
};

export default App;
